/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyDetailResponse } from '../../models/company-detail-response';

export interface GetApiAdministrativeV1Id$Json$Params {
  id: number;
  'X-Permission-Type'?: string;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
}

export function getApiAdministrativeV1Id$Json(http: HttpClient, rootUrl: string, params: GetApiAdministrativeV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiAdministrativeV1Id$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Permission-Type', params['X-Permission-Type'], {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyDetailResponse>;
    })
  );
}

getApiAdministrativeV1Id$Json.PATH = '/private/v1/companies/{id}';
